// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1oKy2","title":"Header_title__vwAEg","side":"Header_side__2dVbP"};